import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import {
  Container, Leading, NavItem, LogoutButton, WorkspacesHeader, WorkspaceItem,
} from './styles';
import Menu from '../../assets/images/menu.svg';
import Drawer from '../Drawer';
import useAuth from '../../hooks/useAuth';
import useQueryWorkspaces from '../../hooks/useQueryWorkspaces';
import Add from '../../assets/images/add.svg';

export default function Header({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const { isAuthenticated, handleLogout } = useAuth();

  const location = useLocation();

  const { data: workspaces, isFetching } = useQueryWorkspaces();

  function handleCloseDrawer() {
    setIsOpen(false);
  }

  return (
    isAuthenticated && (
      <>
        <Drawer isOpen={isOpen} onClose={() => handleCloseDrawer()}>
          <div>
            <nav>
              <ul>
                <NavItem selected={location.pathname === '/overview'}>
                  <Link to="/overview" onClick={() => handleCloseDrawer()}>
                    <strong>
                      Visão Geral
                    </strong>
                  </Link>
                </NavItem>
                <NavItem selected={location.pathname === '/home'}>
                  <Link to="/home" onClick={() => handleCloseDrawer()}>
                    <strong>
                      Home
                    </strong>
                  </Link>
                </NavItem>
                <NavItem selected={location.pathname === '/new-backup'}>
                  <Link to="/new-backup" onClick={() => handleCloseDrawer()}>
                    <strong>
                      Novo Backup
                    </strong>
                  </Link>
                </NavItem>
                <NavItem selected={location.pathname === '/new-company'}>
                  <Link to="/new-company" onClick={() => handleCloseDrawer()}>
                    <strong>
                      Nova Empresa
                    </strong>
                  </Link>
                </NavItem>
                <NavItem selected={location.pathname === '/reports'}>
                  <Link to="/reports" onClick={() => handleCloseDrawer()}>
                    <strong>
                      Relatórios
                    </strong>
                  </Link>
                </NavItem>
              </ul>
            </nav>
            <WorkspacesHeader>
              <span>
                Áreas de Trabalho
              </span>
              <Link to="/new-workspace" onClick={() => handleCloseDrawer()}>
                <img src={Add} alt="Novo" />
              </Link>
            </WorkspacesHeader>
            <ul>
              {!isFetching
                ? workspaces?.map((workspace) => (
                  <WorkspaceItem key={`header${workspace.id}`}>
                    <Link to={`/workspaces/${workspace.id}`} onClick={() => handleCloseDrawer()}>
                      {workspace.name}
                    </Link>
                  </WorkspaceItem>
                )) : <p>Loading...</p>}
            </ul>
          </div>
          <LogoutButton onClick={() => {
            handleCloseDrawer();
            handleLogout();
          }}
          >
            Logout
          </LogoutButton>
        </Drawer>
        <Container>
          {children}
          <Leading type="button" onClick={() => setIsOpen(true)}>
            <img alt="menu" src={Menu} />
          </Leading>

        </Container>
      </>
    )
  );
}

Header.propTypes = {
  children: PropTypes.node,
};

Header.defaultProps = {
  children: null,
};
